import React from "react";

export default function SectionBreak({ children, className = "" }) {
  return (
    <div
      className={`py-16 w-full bg-secondary-light text-primary justify-center text-center ${className}`}
    >
      {children}
    </div>
  );
}
